<div class="overview-container">
  <!-- ADMIN DASHBOARD -->
  @if (loggedInUser) {
    <app-admin-dashboard [project]="'OUTBOUND'"></app-admin-dashboard>
  }

  <!-- SALES LEADS DASHBOARD -->
  @if (!loggedInUser) {
    <app-sales-dashboard [project]="'OUTBOUND'"></app-sales-dashboard>
  }
</div>
